



export default {
data () {
return {
}
},
components: {

},
beforeCreate () {
},
mounted () {

},
beforeDestroy () {

},
methods: {

}
}



// WEBPACK FOOTER //
// ./src/common/components/SaafFooter.vue